import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { UsuarioService } from '../../usuario/usuario.service';
import { ComumService } from '../../comum/comum.service';
import { Evento } from '../../comum/eventos/evento';
import { CookieService } from 'angular2-cookie/core';
import { PermissoesAcessoService } from '../../permissoes-acesso/permissoes-acesso.service';
import { RoleUsuario } from '../../comum/modelos/role-usuario';
import { ClienteService } from '../../cliente/cliente.service';

@Component({
    selector: 'app-user-login',
    templateUrl: './user-login.component.html',
    styleUrls: ['./user-login.component.css']
})
export class UserLoginComponent implements OnInit {

    isNewUser = true;
    email = '';
    password = '';
    errorMessage = '';
    error: { name: string, message: string } = { name: '', message: '' };

    evento: Evento;

    resetPassword = false;

    constructor (public authService: AuthService,
        private _usuarioService: UsuarioService,
        private _comumService: ComumService,
        private _cookieService: CookieService,
        private _permissoesAcessoService: PermissoesAcessoService,
        private _clienteService: ClienteService,
        private _authService: AuthService,
        private router: Router) {
        this.evento = this._comumService.evento;
        if (this.evento !== undefined) {
            setTimeout(() => { this._comumService.cleanEvent(); }, 5000);
        }
    }

    ngOnInit() { }

    checkUserInfo() {
        if (this.authService.isUserEmailLoggedIn) {
            this.router.navigate(['']);
        }
    }

    clearErrorMessage() {
        this.errorMessage = '';
        this.error = { name: '', message: '' };
    }

    changeForm() {
        this.isNewUser = !this.isNewUser;
    }

    onSignUp(): void {
        this.clearErrorMessage();

        if (this.validateForm(this.email, this.password)) {
            this.authService.signUpWithEmail(this.email, this.password)
                .then(() => {
                    this.router.navigate(['']);
                }).catch(_error => {
                    this.error = _error;
                    this.router.navigate(['']);
                });
        }
    }

    onLoginEmail(): void {
        this.clearErrorMessage();

        if (this.validateForm(this.email, this.password)) {
            this.authService.loginWithEmail(this.email, this.password)
                .then(() => {
                    this._usuarioService.obterUsuarioPorUidHttp(this._cookieService.get('uid'))
                        .subscribe(usuario => {
                            this._permissoesAcessoService.obterRolesUsuario(usuario.idUsuario).subscribe(roles => {
                                this._cookieService.putObject('usuario', usuario);
                                this._cookieService.putObject('roles', roles);
                                this._authService.inicializarPermissoesVisualizacao();
                                if (this._authService.isAdmin) {
                                    this.router.navigate(['/selecao-clientes']);
                                } else {
                                    this._clienteService.obterClientePorIdHttp(usuario.idCliente).
                                        subscribe(cliente => {
                                            this._cookieService.putObject('idCliente', usuario.idCliente);
                                            this._cookieService.putObject('cliente', cliente);
                                            this.router.navigate(['']);
                                        });
                                }
                            });
                        });
                })
                .catch(_error => {
                    this.error = _error;
                    this._comumService.evento.incorrectPassword = true;
                    this._comumService.evento.error = true;
                    setTimeout(() => {
                        this.evento.limparEventos();
                    }, 3000);
                    this.router.navigate(['']);
                });
        } else {
            this._comumService.evento.error = true;
            this._comumService.evento.validateLogin = true;
            setTimeout(() => {
                this.evento.limparEventos();
            }, 3000);
        }
    }

    validateForm(email: string, password: string): boolean {
        if (email.length === 0) {
            this.errorMessage = 'Please enter Email!';
            return false;
        }

        if (password.length === 0) {
            this.errorMessage = 'Please enter Password!';
            return false;
        }

        if (password.length < 6) {
            this.errorMessage = 'Password should be at least 6 characters!';
            return false;
        }

        this.errorMessage = '';

        return true;
    }

    isValidMailFormat(email: string) {
        const EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

        if ((email.length === 0) && (!EMAIL_REGEXP.test(email))) {
            return false;
        }

        return true;
    }

    sendResetEmail() {
        this.clearErrorMessage();
        // this.authService.resetPassword(this.email)
        //    .then(() => this.resetPassword = true)
        //    .catch(_error => {
        //        this.error = _error;
        //    });
    }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/auth/user-login/user-login.component.ts